import { CtaType } from 'generated/maya.types';

const ctaTypeKeys = Object.keys(CtaType);
const ctaTypeValues = Object.values(CtaType);
const ctaTypeOptions = ctaTypeValues.map((value, index) => { return { id: ctaTypeKeys[index], label: value }; });

export default ctaTypeOptions;
